import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import DecorativeRange from './pages/DecorativeRange';
import Infrastructure from './pages/Infrastructure';
import Projects from './pages/Projects';
import Enquire from './pages/Enquire';
// import ProjectDetail from './components/projects/ProjectDetail';
import PerformanceAndSaftey from './pages/PerformanceAndSaftey';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/decorativeRange" element={<DecorativeRange />} />
        <Route path="/performanceAndSaftey" element={<PerformanceAndSaftey />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/projects" element={<Projects />} />
        {/* <Route path="/projects/:slug" element={<ProjectDetail />} /> */}
        <Route path="/enquire" element={<Enquire />} />
      </Routes>
    </Router>
  );
}

export default App;
